var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Utility Icons / C / chevrondown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02409 5.99541L6.61182 0.353158C6.77537 0.189615 7.04794 0.189615 7.21148 0.353158L12.7992 5.99541C12.9628 6.15895 12.9628 6.43152 12.7992 6.59507L12.1996 7.19473C12.036 7.35827 11.7634 7.35827 11.5999 7.19473L7.21148 2.7518C7.04794 2.58825 6.77537 2.58825 6.61182 2.7518L2.22341 7.16747C2.05986 7.33101 1.78729 7.33101 1.62375 7.16747L1.02409 6.56781C0.887803 6.40427 0.887803 6.15895 1.02409 5.99541Z",
    fill: "#661C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02409 12.0823L6.61182 6.44007C6.77537 6.27653 7.04794 6.27653 7.21148 6.44007L12.7992 12.0823C12.9628 12.2459 12.9628 12.5184 12.7992 12.682L12.1996 13.2816C12.036 13.4452 11.7634 13.4452 11.5999 13.2816L7.21148 8.83871C7.04794 8.67517 6.77537 8.67517 6.61182 8.83871L2.22341 13.2544C2.05986 13.4179 1.78729 13.4179 1.62375 13.2544L1.02409 12.6547C0.887803 12.4912 0.887803 12.2459 1.02409 12.0823Z",
    fill: "#661C69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.372bf2f0ae18b7b35d5c300c66b52a09.svg";
export { ForwardRef as ReactComponent };